import React, { Fragment, useCallback, useState } from 'react';
import { Row, Col, FormGroup, Label, Input, UncontrolledTooltip } from 'reactstrap';
import Strings from '../../../translations/Translations';
import Slider from 'rc-slider';
import { useAuth } from '../../../Context/Auth/AuthContext';
import PSO from '../../../services/PSO';
import { toast } from 'react-toastify';
import RemixHelper from '../../../helpers/RemixHelper';
import cx from 'classnames';
import Autocomplete from 'react-google-autocomplete';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export default function VideoDetails(props) {
  const { setRemixPars, remixPars, toggleLatiLong } = props;
  const { authenticated, toggleLoading } = useAuth();

  const [showLocation, setShowLocation] = useState(false);

  const checkStarTagExists = useCallback(async (value) => {
    toggleLoading(true, Strings('checking_if_startag_exists'));
    let startagExists;
    try {
      
      const response = await PSO.checkStarTagExists({
        un: authenticated.un,
        al: authenticated.al,
        rstag: value
      });
      if (response && response.result) {
        if (response.result === 'success') {
          if (response.systemstartagexists && (response.systemstartagexists === 1 || response.systemstartagexists === '1')) {
            startagExists = true;
          }
          if (response.userstartagexists && (response.userstartagexists === 1 || response.userstartagexists === '1')) {
            startagExists = true;
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
    toggleLoading(false);

    if (startagExists) {
      toast.error(Strings('startag_already_exists'));
    }
  }, [authenticated, toggleLoading]);

  return (
    <Fragment>
      <Row>
        <FormGroup tag={Col} md={6}>
          <Label for="campaign_name">
            {Strings('title')} 
            <span className='ml-1'><i id='rti-info' className='pe-7s-info'></i></span>
          </Label>
          <UncontrolledTooltip
            placement='right'
            target='rti-info'
          >
            {Strings('title_tooltip')}
          </UncontrolledTooltip>

          <Input
            type="text"
            name="rti"
            id="rti"
            defaultValue={remixPars && remixPars.rti}
            onBlur={(evt) => {
              const genStarTag = RemixHelper.generateStarTag(evt.target.value);
              setRemixPars({
                ...remixPars,
                rti: evt.target.value,
                rstag: genStarTag 
              });
            }}
          />
        </FormGroup>
        <FormGroup tag={Col} md={6}>
          <Label for="campaign_name">
            {Strings('startag')}
            <span className='ml-1'><i id='rstag-info' className='pe-7s-info'></i></span>
          </Label>
          <UncontrolledTooltip
            placement='right'
            target='rstag-info'
          >
            {Strings('startag_tooltip')}
          </UncontrolledTooltip>

          <Input
            type="text"
            name="rstag"
            id="rstag"
            value={remixPars && remixPars.rstag}
            onChange={(evt) => {
              let startag = evt.target.value;
              if (startag) {
                startag = RemixHelper.generateStarTag(startag);
                if (startag) {
                  setRemixPars({ ...remixPars, rstag: startag });
                }
              }
            }}
            onBlur={(evt) => {
              let startag = evt.target.value;
              if (startag) {
                checkStarTagExists(startag);
              }
            }}
          />
        </FormGroup>
        <FormGroup tag={Col} md={12}>
          <Label for="campaign_name">
            {Strings('description')}
            <span className='ml-1'><i id='rde-info' className='pe-7s-info'></i></span>
          </Label>
          <UncontrolledTooltip
            placement='right'
            target='rde-info'
          >
            {Strings('description_tooltip')}
          </UncontrolledTooltip>

          <Input
            type="textarea"
            name="rde"
            id="rde"
            defaultValue={remixPars && remixPars.rde}
            onBlur={(evt) => setRemixPars({ ...remixPars, rde: evt.target.value })}
          />
        </FormGroup>
      </Row>
      <Row className="mb-3">
        <Col md={4}>
          <p>
            {Strings('video_clip_sound_allowed')}
            <span className='ml-1'><i id='rmcsa-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rmcsa-info'
          >
            {Strings('rmcsa_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rmcsa: remixPars.rmcsa === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rmcsa !== 'undefined' && parseInt(remixPars.rmcsa) === 1,
                'switch-off': remixPars && remixPars.rmcsa !== 'undefined' && parseInt(remixPars.rmcsa) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('auto_approve_media')}
            <span className='ml-1'><i id='rautoapp-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rautoapp-info'
          >
            {Strings('rautoapp_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rautoapp: remixPars.rautoapp === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rautoapp !== 'undefined' && parseInt(remixPars.rautoapp) === 1,
                'switch-off': remixPars && remixPars.rautoapp !== 'undefined' && parseInt(remixPars.rautoapp) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('show_sent_message')}
            <span className='ml-1'><i id='rssm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rssm-info'
          >
            {Strings('rssm_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rssm: remixPars.rssm === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rssm !== 'undefined' && parseInt(remixPars.rssm) === 1,
                'switch-off': remixPars && remixPars.rssm !== 'undefined' && parseInt(remixPars.rssm) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={4}>
          <p>
            {Strings('show_media_message')}
            <span className='ml-1'><i id='rsmir-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rsmir-info'
          >
            {Strings('rsmir_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rsmir: remixPars.rsmir === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rsmir !== 'undefined' && parseInt(remixPars.rsmir) === 1,
                'switch-off': remixPars && remixPars.rsmir !== 'undefined' && parseInt(remixPars.rsmir) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('stop_to_receive_media')}
            <span className='ml-1'><i id='blksnow-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='blksnow-info'
          >
            {Strings('blksnow_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, blksnow: remixPars.blksnow === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.blksnow !== 'undefined' && parseInt(remixPars.blksnow) === 1,
                'switch-off': remixPars && remixPars.blksnow !== 'undefined' && parseInt(remixPars.blksnow) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <p>
            {Strings('allow_media_download')}
            <span className='ml-1'><i id='rdmdown-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rdmdown-info'
          >
            {Strings('rmdown_tooltip')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, rdmdown: remixPars.rdmdown === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.rdmdown !== 'undefined' && parseInt(remixPars.rdmdown) === 0,
                'switch-off': remixPars && remixPars.rdmdown !== 'undefined' && parseInt(remixPars.rdmdown) === 1
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col md={4}>
          <p>
            {Strings('feature_video_in_popfans')}
            <span className='ml-1'><i id='featVideoPopFans-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='featVideoPopFans-info'
          >
            {Strings('your_video_URL_domain_will_be_popfans')}
          </UncontrolledTooltip>

          <div
            className="switch has-switch mb-2 mr-2"
            data-on-label={Strings('on_label')}
            data-off-label={Strings('off_label')}
            onClick={() => setRemixPars({ ...remixPars, featVideoPopFans: remixPars.featVideoPopFans === 1 ? 0 : 1 })}
          >
            <div
              className={cx("switch-animate", {
                'switch-on': remixPars && remixPars.featVideoPopFans !== 'undefined' && parseInt(remixPars.featVideoPopFans) === 1,
                'switch-off': remixPars && remixPars.featVideoPopFans !== 'undefined' && parseInt(remixPars.featVideoPopFans) === 0
              })}
            >
              <input type="checkbox"/>
              <span className="switch-left">{Strings('on_label')}</span>
              <label>&nbsp;</label>
              <span className="switch-right">{Strings('off_label')}</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <p>
            {Strings('featured_score_for_OWNER_new_media')} 
            {remixPars && remixPars.rfsownernm && <small className='ml-1'>{`(${remixPars.rfsownernm})`}</small>}
            <span className='ml-2'><i id='rfsownernm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rfsownernm-info'
          >
            {Strings('rfsownernm_tooltip')}
          </UncontrolledTooltip>

          <Slider
            className="mb-2"
            min={1}
            max={99}
            value={remixPars && remixPars.rfsownernm !== 'undefined' && parseInt(remixPars.rfsownernm)}
            defaultValue={remixPars && remixPars.rfsownernm !== 'undefined' && parseInt(remixPars.rfsownernm)}
            onChange={(value) => setRemixPars({ ...remixPars, rfsownernm: value })}
          />
        </Col>
        <Col md={6}>
          <p>
            {Strings('featured_score_for_new_media')}
            {remixPars && remixPars.rfsnm && <small className='ml-1'>{`(${remixPars.rfsnm})`}</small>}
            <span className='ml-2'><i id='rfsnm-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='rfsnm-info'
          >
            {Strings('rfsnm_tooltip')}
          </UncontrolledTooltip>

          <Slider
            className="mb-2"
            min={1}
            max={99}
            value={remixPars && remixPars.rfsnm !== 'undefined' && parseInt(remixPars.rfsnm)}
            defaultValue={remixPars && remixPars.rfsnm !== 'undefined' && parseInt(remixPars.rfsnm)}
            onChange={(value) => setRemixPars({ ...remixPars, rfsnm: value })}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={12}>
          <p
            className='pointer'
            onClick={() => setShowLocation(!showLocation)}
          >
            {Strings('location')}
            <span className='ml-2'><i id='location-info' className='pe-7s-info'></i></span>
          </p>
          <UncontrolledTooltip
            placement='right'
            target='location-info'
          >
            {Strings('edit_the_location_for_the_video')}
          </UncontrolledTooltip>
          <Autocomplete
            className={`form-control ${(!showLocation) ? "d-none" : ""}`}
            apiKey={GOOGLE_MAPS_API_KEY}
            onPlaceSelected={(place) => {
              if (toggleLatiLong && place && place.formatted_address) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                toggleLatiLong(lat, lng);
              }
            }}
            options={{ types: [] }}
          />
        </Col>
      </Row>
    </Fragment>
  );
}